var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8645 11.8208H12.0515L11.7633 11.5429C12.7719 10.3696 13.3791 8.84648 13.3791 7.18954C13.3791 3.49485 10.3842 0.5 6.68954 0.5C2.99485 0.5 0 3.49485 0 7.18954C0 10.8842 2.99485 13.8791 6.68954 13.8791C8.34648 13.8791 9.86964 13.2719 11.0429 12.2633L11.3208 12.5515V13.3645L16.4666 18.5L18 16.9666L12.8645 11.8208ZM6.68954 11.8208C4.12693 11.8208 2.05832 9.75214 2.05832 7.18954C2.05832 4.62693 4.12693 2.55832 6.68954 2.55832C9.25214 2.55832 11.3208 4.62693 11.3208 7.18954C11.3208 9.75214 9.25214 11.8208 6.68954 11.8208Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.fe95060b9746d1ca4fe69e5459e28331.svg";
export { ForwardRef as ReactComponent };